"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Type = exports.BaseChart = exports.BasePage = exports.useChart = exports.createChart = exports.echarts = void 0;
var factory_1 = __importDefault(require("./common/factory"));
var BasePage_1 = __importDefault(require("./interface/BasePage"));
exports.BasePage = BasePage_1.default;
var BaseChart_1 = __importDefault(require("./interface/BaseChart"));
exports.BaseChart = BaseChart_1.default;
var chart_1 = require("./types/chart");
Object.defineProperty(exports, "Type", { enumerable: true, get: function () { return chart_1.Type; } });
var chart_2 = __importDefault(require("./component/chart"));
exports.createChart = chart_2.default;
var usechart_1 = __importDefault(require("./component/usechart"));
exports.useChart = usechart_1.default;
var throttle_1 = __importDefault(require("lodash/throttle"));
var BasePage_2 = __importDefault(require("./interface/BasePage"));
var echarts = __importStar(require("echarts"));
exports.echarts = echarts;
var default_1 = /** @class */ (function () {
    function default_1(options, _a) {
        var theme = _a.theme, env = _a.env;
        this.$charts = [];
        options.page = options.page || {};
        this.$env = env || "production";
        this.windowResize = throttle_1.default(this.windowResize.bind(this), 80);
        // 开始初始化图表实例、但未挂载
        this.init(options);
    }
    /**
     * 实例化
     */
    default_1.prototype.init = function (options) {
        var _this = this;
        this.$page = new BasePage_2.default(options.page);
        this.$charts = options.charts.map(function (item) {
            if (item instanceof BaseChart_1.default) {
                return item;
            }
            else {
                return factory_1.default(item, _this.$page);
            }
        });
    };
    /**
     * 挂载
     * @param el
     */
    default_1.prototype.amount = function (el) {
        var _this = this;
        var $el;
        if (typeof el === "string") {
            $el = document.getElementById(el);
        }
        else {
            $el = el;
        }
        if (!$el) {
            throw Error("el is not exist !!!");
        }
        this.$page.amount($el);
        this.$charts.forEach(function (chart) {
            var el = document.createElement("div");
            chart.amount(el, _this.$page);
        });
        return this.$charts;
    };
    /**
     * 导出配置信息
     */
    default_1.prototype.export = function () {
        if (!this.$page) {
            return;
        }
        return {
            page: this.$page.export(),
            charts: this.$charts.map(function (chart) {
                return chart.export().charts;
            })
        };
    };
    /**
     * 大小更改后重新渲染图表
     */
    default_1.prototype.windowResize = function () {
        this.$charts.map(function (chart) {
            chart.forceUpdate();
        });
    };
    /**
     * 销毁所有图表
     */
    default_1.prototype.remove = function () {
        this.$charts.map(function (chart) {
            // chart.$chart.dispose();
            chart.remove();
        });
        this.$page && this.$page.$el.remove();
        window.removeEventListener("resize", this.windowResize);
    };
    /**
     * 动态添加一个图表
     * @param component
     */
    default_1.prototype.add = function (component) { };
    return default_1;
}());
exports.default = default_1;
//# sourceMappingURL=index.js.map